import * as React from "react";

function SvgChangeUserRole(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.38 0c-8.667 0-6 10-3.333 14-2.814.703-4.885 2.314-6.33 4.222h5.167c2.999 0 4.116 1.237 4.116 3.111v.978h1.23c.199 0 .595.125.595.622v1.245h10.657C27.694 20.393 24.847 15.4 19.714 14c2.444-5.333 5.333-14-3.334-14zM0 24.044v9.245c0 2.311 2.207 4.044 4.414 4.044h6.62c2.207 0 3.31-1.733 3.31-2.889v-1.733H16c.441 0 .552-.385.552-.578v-1.155h1.655s.799 1.155 1.103 1.155c.305 0 1.104-1.155 1.104-1.155H24.275s.772 1.155 1.104 1.155c.332 0 1.104-1.155 1.104-1.155h1.103l3.862-1.734s.552-.258.552-.577c0-.32-.552-.578-.552-.578l-3.862-1.733H16.552V25.2c0-.462-.368-.578-.552-.578h-1.655V22.89c0-1.156-1.104-2.889-3.31-2.889H4.413C2.207 20 0 21.733 0 24.044z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgChangeUserRole;
